import MP4Box from 'mp4box';

export default {
  methods: {
    getVideoInfo(file, mp4boxfile) {
      const url = URL.createObjectURL(file);
      mp4boxfile = MP4Box.createFile();
      return this.playMp4(url, mp4boxfile);
    },
    getVideoTracks(info) {
      // video tracks have width and height, use random value of 480 pixels here
      return info.tracks.filter(o => _.get(o, 'trackWidth') >= 320 && _.get(o, 'trackHeight') >= 240);
    },
    getVideoTrackResolution(info) {
      const videoTrack = this.getVideoTracks(info).length ? this.getVideoTracks(info)[0] : null;
      return { width: _.get(videoTrack, 'trackWidth', 0), height: _.get(videoTrack, 'trackHeight', 0) };
    },
    getVideoCodecs(info) {
      const videoTracks = this.getVideoTracks(info);
      return videoTracks.map(({ codec }) => codec.split('.')[0].replace(/ /g, ''));
    },
    playMp4(url, mp4boxfile) {
      return new Promise((resolve) => {
        this.bindMp4box(url, mp4boxfile, resolve);
        fetch(url)
          .then((response) => response.arrayBuffer())
          .then((arrayBuffer) => {
            arrayBuffer.fileStart = 0;
            mp4boxfile.appendBuffer(arrayBuffer);
            mp4boxfile.flush();
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },
    bindMp4box(url, mp4boxfile, resolve) {
      mp4boxfile.onError = (e) => {
        console.log(e);
      };
      mp4boxfile.onReady = (info) => {
        console.log(info);
        // const video = document.querySelector('.js-player-mp4');
        // video.src = url;
        // video.play();
        // this.showVideoInfo(info);
        resolve(info);
      };
    },
    showVideoInfo(info) {
      const videoTrack = info.tracks[0];
      const codec = videoTrack.codec;
      console.log('codec: ', codec);
      if (['avc1', 'hev1', 'hvc1'].includes(codec.split('.')[0])) {
        console.log('%c ACCEPTED', 'color: green');
      } else {
        console.log('%c ONLY h.264, h.265 codec accepted', 'color: red');
      }
      // const audioTrack = info.tracks[1];
      // console.log(audioTrack);
    },
  },
};
